import { PlanState } from "../types"
import { SelectableHsa } from "./hsa"
import { SelectableSoilAssessment } from "./sa"
import { SelectableStdAnalysis } from "./std"
import { AnalysisType } from "./type"

type SelectableType = SelectableStdAnalysis | SelectableHsa | SelectableSoilAssessment

export function selectAnalysis(state: PlanState, target: AnalysisType, selected: boolean) {

    const { type, analysis } = target
    const { selectedField: field } = state

    const updated = field.analysis[type].map((g: SelectableType) => g !== analysis
        ? g
        : {
            ...g,
            selected: {
                ...g.selected,
                value: selected
            }
        }
    )

    return {
        ...state,
        selectedField: {
            ...field,
            analysis: {
                ...field.analysis,
                [type]: updated
            }
        }
    }

}
